import React, { useState, useEffect } from 'react';
import MapView from './MapView';
import ObservationTable from './ObservationTable';
import { PanelGroup, Panel, PanelResizeHandle } from 'react-resizable-panels';

function App() {
  const [selectedPolygons, setSelectedPolygons] = useState([]);
  const [observationsData, setObservationsData] = useState([]);

  // 日付＋午前午後
  const today = new Date().toISOString().slice(0, 10);
  const [selectedDate, setSelectedDate] = useState(today);
  const [period, setPeriod] = useState('am');

  const handleSelect = (selectedRows) => {
    const polygons = selectedRows
      .map((row) => row.polygon)
      .filter((polygon) => Array.isArray(polygon));
    setSelectedPolygons(polygons);
  };

  // 日付＋午前午後でファイルパスを決定
  useEffect(() => {
    if (!selectedDate) return;

    const hour = period === 'am' ? 'DSC' : 'ASC';
    const yyyymmdd = selectedDate.replace(/-/g, '');
    const filePath = `/data/observations/${yyyymmdd}_${hour}.json`;

    console.log('観測データ読み込み:', filePath);

    fetch(filePath)
      .then((res) => {
        if (!res.ok) throw new Error('観測データ読み込みエラー');
        return res.json();
      })
      .then((data) => setObservationsData(data))
      .catch((err) => {
        console.error(err);
        setObservationsData([]);
      });
  }, [selectedDate, period]);

  return (
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <h1 style={{ margin: '10px' }}>台風情報と衛星観測要求 0.1</h1>
      <PanelGroup direction="vertical" style={{ flex: 1 }}>
        <Panel defaultSize={70}>
          <MapView
            selectedPolygons={selectedPolygons}
            selectedDate={selectedDate}
            period={period}
            onDatePeriodChange={({ selectedDate, period }) => {
              setSelectedDate(selectedDate);
              setPeriod(period);
            }}
          />
        </Panel>
        <PanelResizeHandle style={{ height: '4px', background: '#ccc', cursor: 'row-resize' }} />
        <Panel>
          <ObservationTable data={observationsData} onSelect={handleSelect} />
        </Panel>
      </PanelGroup>
    </div>
  );
}

export default App;
